<template>
  <div
    :class="['to-top', { visible: isVisible }]"
    @click="scrollToTop"
  >
    <f-sprite-icon :icon-link="$options.icons.IconArrow" />
  </div>
</template>

<script>
import { productGtmEvents } from '@/gtm/product';

import IconArrow from '../../assets/icons/arrow.svg';

export default {
  name: 'ToTop',

  icons: {
    IconArrow,
  },

  data() {
    return {
      observer: null,
      target: null,
      isVisible: false,
    };
  },

  mounted() {
    this.startObserver();
  },

  beforeUnmount() {
    this.stopObserver();
  },

  methods: {
    startObserver() {
      this.target = document.getElementById('header');
      if (!this.target) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isVisible = !entry.isIntersecting;
        });
      });

      this.observer.observe(this.target);
    },

    stopObserver() {
      if (this.observer && this.target) {
        this.observer.unobserve(this.target);
        this.observer = null;
      }
    },

    scrollToTop() {
      this.sendGtmEvent();

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },

    sendGtmEvent() {
      if (this.$route.name === 'Category') {
        productGtmEvents.productListItem.onClickPageUpBtn();
      }
    },
  },
};
</script>

<style lang="scss">
$mobileHeight: 40px;
$desktopHeight: 48px;
$mobileMarginBottom: 128px;
$desktopMarginBottom: 161px;

.to-top {
  @include stacking("to-top");
  position: sticky;
  bottom: 26px;
  left: 100%;
  width: 40px;
  height: $mobileHeight;
  padding: 10px;
  margin-right: 8px;
  margin-top: -$mobileHeight + -$mobileMarginBottom;
  margin-bottom: $mobileMarginBottom;
  border: 1px solid $gray_lu;
  background-color: #fff;
  border-radius: 50%;
  color: $gray;
  cursor: pointer;
  opacity: 0;
  transition: background-color .2s ease, color .2s ease, opacity .2s ease;

  &.visible {
    opacity: 1;
  }
}

@include breakpoint("tablet") {
  .to-top {
    margin-top: -$mobileHeight + -$mobileMarginBottom;
  }
}

@include breakpoint("desktop") {
  .to-top {
    bottom: 59px;
    margin-top: -$desktopHeight + -$desktopMarginBottom;
    margin-right: 24px;
    margin-bottom: $desktopMarginBottom;
    width: 48px;
    height: $desktopHeight;
    padding: 12px;

    &:hover {
      color: $black;
      background-color: $gray_bgr;
    }
  }
}
</style>
